var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRaughDraftInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.125 24.125L33.375 20.375C32.875 19.875 32.125 19.875 31.625 20.375L20 32V37.5H25.5L37.125 25.875C37.625 25.375 37.625 24.625 37.125 24.125ZM24.5 35H22.5V33L28.75 26.75L30.75 28.75L24.5 35ZM32.5 27L30.5 25L32.5 23L34.5 25L32.5 27ZM12.5 28.75H15V31.25H12.5V28.75ZM17.5 22.5H22.5V25H17.5V22.5ZM12.5 22.5H15V25H12.5V22.5ZM17.5 16.25H27.5V18.75H17.5V16.25ZM12.5 16.25H15V18.75H12.5V16.25Z",
    fill: "#404040"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 35V8.75H12.5V12.5H27.5V8.75H31.25V16.25H33.75V8.75C33.75 7.375 32.625 6.25 31.25 6.25H27.5V5C27.5 3.625 26.375 2.5 25 2.5H15C13.625 2.5 12.5 3.625 12.5 5V6.25H8.75C7.375 6.25 6.25 7.375 6.25 8.75V35C6.25 36.375 7.375 37.5 8.75 37.5H15V35H8.75ZM15 5H25V10H15V5Z",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaughDraftInactive);
export default __webpack_public_path__ + "static/media/raughDraftInactive.7455ad703ef6d81f8c077616a91fcdcc.svg";
export { ForwardRef as ReactComponent };